var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuoTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 62,
    viewBox: "0 0 55 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1562 52.4277C49.3477 53.1426 50.0625 54.334 50.0625 55.6445V57.3125C50.0625 59.457 48.2754 61.125 46.25 61.125H8.125C5.98047 61.125 4.3125 59.457 4.3125 57.4316V55.6445C4.3125 54.334 4.9082 53.1426 6.09961 52.4277L11.9375 48.7344C5.02734 43.9688 0.5 35.9863 0.5 26.8125C0.5 12.1582 12.4141 0.125 27.1875 0.125C41.8418 0.125 53.875 12.1582 53.875 26.8125C53.875 35.9863 49.2285 43.9688 42.3184 48.7344L48.1562 52.4277ZM27.1875 45.875C37.6719 45.875 46.1309 37.5352 46.1309 26.9316C46.1309 16.4473 37.4336 7.86914 27.0684 7.86914C16.584 7.86914 8.00586 16.5664 8.00586 26.9316C8.00586 37.416 16.584 45.875 27.1875 45.875Z",
    fill: "#25272C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 11.5625C35.5273 11.5625 42.3184 18.4727 42.3184 26.8125C42.3184 35.2715 35.5273 42.0625 27.0684 42.0625C18.7285 42.0625 11.8184 35.2715 11.8184 26.8125C11.8184 18.4727 18.7285 11.5625 27.1875 11.5625ZM27.0684 21.0938C28.1406 21.0938 28.9746 20.2598 28.9746 19.1875C28.9746 18.2344 28.1406 17.2812 27.0684 17.2812C21.8262 17.2812 17.6562 21.5703 17.5371 26.8125C17.5371 27.8848 18.4902 28.7188 19.4434 28.7188C20.5156 28.7188 21.3496 27.8848 21.3496 26.8125C21.4688 23.7148 23.9707 21.0938 27.0684 21.0938Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoTone);
export default __webpack_public_path__ + "static/media/duo_tone.4e48ba872e0feb2d2dc21af0fc15ea78.svg";
export { ForwardRef as ReactComponent };